module.exports = __webpack_public_path__ + "img/patient-info-identification.d877f60a.svg";